import RxSelectBox from "./RxSelectBox";

export default RxSelectBox;
